/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReserveTripMapTerminalStatus
 */
export interface ReserveTripMapTerminalStatus {
    /**
     * available / pause
     * @type {string}
     * @memberof ReserveTripMapTerminalStatus
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMapTerminalStatus
     */
    locCoords?: string;
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMapTerminalStatus
     */
    ts?: string;
}

export function ReserveTripMapTerminalStatusFromJSON(json: any): ReserveTripMapTerminalStatus {
    return ReserveTripMapTerminalStatusFromJSONTyped(json, false);
}

export function ReserveTripMapTerminalStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveTripMapTerminalStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'locCoords': !exists(json, 'loc_coords') ? undefined : json['loc_coords'],
        'ts': !exists(json, 'ts') ? undefined : json['ts'],
    };
}

export function ReserveTripMapTerminalStatusToJSON(value?: ReserveTripMapTerminalStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'loc_coords': value.locCoords,
        'ts': value.ts,
    };
}


